import React from "react";

const WoType = ({ serviceType }) => {
  return <div className="w-[100px] h-[22px] flex items-center justify-center rounded-[11px] font-OpenSansRegular font-[400] text-titleColor text-[10px]" style={{ backgroundColor: serviceType?.backgroundColor }}>
    {serviceType?.serviceType}
  </div>
};

export default WoType;
